import React, { PropsWithChildren, useState } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from '../../../../../utils/type'
import { Me } from '../../../../../service/user'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { PreviewTag } from 'components/tag/PreviewTag'
import { PriceInfoGuideTooltip } from '../PriceInfoGuideTooltip'
import useTranslation from '../../../../../hooks/useTranslation'

interface PriceDisplayProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  userInfo: Me
}
export const PriceDisplay = ({
  watch,
  setValue,
  control,
  userInfo,
}: PropsWithChildren<PriceDisplayProps>) => {
  const { t } = useTranslation()
  const [isOpenPurchaseInfoGuideModal, setIsOpenPurchaseInfoGuideModal] =
    useState<boolean>(false)
  return (
    <div className="price  my-[40px]">
      <div className="flex flex-col md:mb-[16px] gap-4 ">
        <p className="font-bold text-[18px] flex items-center gap-3 relative">
          {t('productVideoEditor.testEffect.productPriceInfo')}
          <PreviewTag setIsOpenModal={setIsOpenPurchaseInfoGuideModal} />
          {isOpenPurchaseInfoGuideModal && (
            <PriceInfoGuideTooltip
              setIsOpenPurchaseInfoGuideModal={setIsOpenPurchaseInfoGuideModal}
            />
          )}
        </p>
        <div className="grid grid-cols-2 ">
          {[
            { name: t('productVideoEditor.testEffect.include'), value: true },
            { name: t('productVideoEditor.testEffect.exclude'), value: false },
          ].map((el, index) => {
            return (
              <div key={index}>
                <label
                  onClick={() => {
                    setValue('includePrice', el.value)
                  }}
                >
                  <Controller
                    render={({ field }) => (
                      <CircularCheckbox
                        {...field}
                        id={index}
                        checked={watch('includePrice') === el.value}
                        label={el.name}
                        onChange={() => {
                          setValue('includePrice', el.value)
                        }}
                        disabled={
                          !userInfo || userInfo?.userType === 'normalUser'
                        }
                      />
                    )}
                    name="includePrice"
                    control={control}
                  />
                </label>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
